import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import useAuthenticationStore, { AuthenticationViews } from './Store';
import LoginPassword from "./LoginPassword"

const LoginPasswordContainer: React.FC = () => {
  const { state, dispatch, isValidPassword, finishLogin, forgotPassword, setRememberMe } = useAuthenticationStore()
  const { emailOrPhone, isLoading, rememberMe, serverError } = state
  const navigate = useNavigate();

  const handleSetRememberMe = (newRememberMe: boolean) => {
    setRememberMe(newRememberMe)
  }

  const setEmailOrPhone = (newEmailOrPhone: string) => {
    dispatch({ type: 'SET_EMAIL_OR_PHONE', payload: newEmailOrPhone })
  }

  useEffect(() => {
    if (!emailOrPhone) {
      navigate('../' + AuthenticationViews.login)
    }
  }, [emailOrPhone, navigate])

  return (
    <LoginPassword
      emailOrPhone={emailOrPhone}
      isLoading={isLoading}
      rememberMe={rememberMe}
      serverError={serverError}
      notYouLink={"../" + AuthenticationViews.login}
      isValidPassword={isValidPassword}
      finishLogin={finishLogin}
      forgotPassword={forgotPassword}
      setEmailOrPhone={setEmailOrPhone}
      setRememberMe={handleSetRememberMe}
    />
  )
}

export default LoginPasswordContainer;